import { useNavigate } from 'react-router-dom';
import FullCalendar from '@fullcalendar/react'
import dayGridPlugin from "@fullcalendar/daygrid";
import { Box, Button, Flex, Text, useDisclosure } from '@chakra-ui/react';

import { eventsStyle } from 'theme/fullcalendar';
import BeneficiaryEvent from 'components/BeneficiaryEvent';
import { EventContentArg } from '@fullcalendar/core';
import CalendarEvent from 'components/CalendarEvent';

const events = [
    {
        id: '1',
        title: 'Fulaninho',
        date: '2024-09-27 10:00:00',
        backgroundColor: '#4299E1',
        borderColor: '#4299E1'
    },
    {
        id: '2',
        title: 'Fulaninho',
        date: '2024-09-27 10:10:00',
        backgroundColor: '#F56565',
        borderColor: '#F56565'
    },
    {
        id: '3',
        title: 'Fulaninho',
        date: '2024-09-27 10:40:00',
        backgroundColor: '#ED8936',
        borderColor: '#ED8936'
    },
    {
        id: '4',
        title: 'Fulaninho',
        date: '2024-09-27 10:50:00',
        backgroundColor: '#48BB78',
        borderColor: '#48BB78'
    },
]

const renderEventContent = (eventInfo: EventContentArg) => {
    return <CalendarEvent label={`${eventInfo.timeText} - ${eventInfo.event._def.title}`} />
};

const MonthCalendar = () => {
    const navigate = useNavigate()
    const today = new Date()
    const { isOpen, onOpen, onClose } = useDisclosure()

    return (
        <Flex w="full" minH="1200px" direction="column" >
            <BeneficiaryEvent isOpen={isOpen} onClose={onClose} title="Novo Agendamento" />
            <Box ml="auto" mb="4">
                <Button colorScheme="green" onClick={onOpen}>Novo Agendamento</Button>
            </Box>
            <FullCalendar
                locale="pt-br"
                lazyFetching={false}
                plugins={[dayGridPlugin]}
                initialView='dayGridMonth'
                weekends={true}
                events={events}
                buttonText={{ today: 'HOJE' }}
                eventContent={renderEventContent}
                initialDate={today}
                eventClick={({ event }) => navigate(`/eventos/${event.id}`)}
                eventTimeFormat={{
                    hour: '2-digit',
                    minute: '2-digit',
                    meridiem: false,
                }}
                {...eventsStyle}
            />
        </Flex>
    )
}

export default MonthCalendar